module.exports = __webpack_public_path__ + "img/lt-icone-email-gris-clair.209f55d6.svg";